<template>
    <div class="messages-container">
        <div
            v-if="areAlerts"
            class="messages">
            <AlertMessage
                v-for="(message, index) in alerts"
                :key="message.uuid"
                flash-type="alert"
                :message="message"
                @dismiss="dismissAlert(index)"></AlertMessage>
        </div>

        <div
            v-if="areFlashMessages"
            class="messages">
            <FlashMessage
                v-for="(message, index) in filteredFlashMessages"
                :key="message.uuid"
                flash-type="flash"
                :message="message"
                @dismiss="dismissFlash(index)"></FlashMessage>
        </div>
    </div>
</template>

<script>
    import { flashMessages } from "@eg_ui/src/mixins/globals/flashMessages";
    import { defineAsyncComponent } from "vue";

    export default {
        components: {
            AlertMessage: defineAsyncComponent(
                () => import("@eg_ui/src/components/flashes/client/AlertMessage/AlertMessage.vue"),
            ),
            FlashMessage: defineAsyncComponent(
                () => import("@eg_ui/src/components/flashes/client/FlashMessage/FlashMessage.vue"),
            ),
        },
        mixins: [flashMessages],
        props: {
            config: {
                type: Object,
                default: function () {
                    return {};
                },
            },
        },
    };
</script>

<style lang="scss">
    @use "./FlashMessages.scss";
</style>
